import { Strings } from "@/locales/types/enums/strings";
import { LinkItemCode } from "./enums/link-item-code";
import { LinkItem } from "./LinkItem";
import { publisher } from "@ca.vmedia.tv/domains";
export enum ShowAllContentType {
    Channels = "channels",
    NewSeries = "NewSeries",
    NewMovies = "NewMovies",
    RecommendedSeries = "RecommendedSeries",
    RecommendedMovies = "RecommendedMovies",
    GenreSubItems = "GenreSubItems",
    MostPopularVod = "MostPopularVod",
    ContinueWatching = "ContinueWatching",
    WatchAgain = "WatchAgain",
    Trends = "Trends",
    Movies = "Movies",
    Sports = "Sports",
    Kids = "Kids",
    News = "News",
    RecentlyOnDemand = "RecentlyOnDemand",
    Olympics = "Olympics",
    Shows = "Shows",
    Live = "Live",
    Credits = "Credits",
    LiveSeries = "LiveSeries",
}


export const linkItems: {[key: string]: LinkItem} = {
    root: new LinkItem('', LinkItemCode.Root, "/"),
    error: new LinkItem('', LinkItemCode.Error, "/app-error"),
    home: new LinkItem(Strings.MENU_HOME, LinkItemCode.Home, "/home"),
    guide: new LinkItem(Strings.MENU_GUIDE, LinkItemCode.Guide, "/guide"),
    guideHealtHub: new LinkItem(
        Strings.MENU_GUIDE, 
        LinkItemCode.Guide, 
        "/guide",
        "IconHome"
    ),
    onDemand: new LinkItem(
        Strings.MENU_ON_DEMAND,
        LinkItemCode.OnDemand,
        "/vod"
    ),
    myTv: new LinkItem(Strings.MENU_MYTV, LinkItemCode.MyTv, "/mytv"),
    search: new LinkItem(
        Strings.MENU_SEARCH,
        LinkItemCode.Search,
        "/search",
        "IconSearch"
    ),
    settings: new LinkItem(
        Strings.MENU_SETTINGS,
        LinkItemCode.Settings,
        "/settings",
        "IconSettings"
    ),
    showAllChannels: new LinkItem(
        Strings.VOD_CHANNELS,
        LinkItemCode.Channels,
        `/vod/show-all-channels`
    ),
    showAllPrograms: new LinkItem(
        Strings.MY_TV_ALL_PROGRAMS,
        LinkItemCode.allPrograms,
        `/mytv/all-programs`
    ),
    showAllFavChannels: new LinkItem(
        Strings.MY_TV_FAVORITE_CHANNELS,
        LinkItemCode.favChannels,
        `/mytv/show-all-fav-channels`
    ),
    showAllOnDemand: new LinkItem(
        Strings.MY_TV_ALL_ON_DEMANDS,
        LinkItemCode.allOnDemand,
        `/mytv/all-on-demand`
    ),
    showAllNewShows: new LinkItem(
        Strings.VOD_NEW_SHOWS,
        LinkItemCode.NewShows,
        `/vod/show-all?type=${ShowAllContentType.NewSeries}`
    ),
    showAllNewMovies: new LinkItem(
        Strings.VOD_NEW_MOVIES,
        LinkItemCode.NewMovies,
        `/vod/show-all?type=${ShowAllContentType.NewMovies}`
    ),
    showAllRecommendedShows: new LinkItem(
        Strings.VOD_RECOMMENDED_SHOWS,
        LinkItemCode.RecommendedShows,
        `/vod/show-all?type=${ShowAllContentType.RecommendedSeries}`
    ),
    showAllRecommendedMovies: new LinkItem(
        Strings.VOD_RECOMMENDED_MOVIES,
        LinkItemCode.RecommendedMovies,
        `/vod/show-all?type=${ShowAllContentType.RecommendedMovies}`
    ),
    subgenres: new LinkItem(
        Strings.VOD_SUBGENRES,
        LinkItemCode.SubGenres,
        "/vod/genres"
    ),
    subgenresPremium: new LinkItem(
        Strings.VOD_SUBGENRES,
        LinkItemCode.SubGenrePremium,
        "/vod/genres-premium"
    ),
    showAllVodAllMovies: new LinkItem(
        Strings.VOD_MOVIES,
        LinkItemCode.ShowAllVodAllMovies,
        `/vod/show-all-movies`
    ),
    showAllForGenre: new LinkItem(
        Strings.VOD_SUBGENRES,
        LinkItemCode.SubGenresContent,
        `/vod/show-all-subitems`
    ),
    detailGenre: new LinkItem(
        Strings.VOD_DETAIL_GENRES,
        LinkItemCode.DetailGenre,
        `/vod/detail-genre`
    ),
    account: new LinkItem(
        Strings.SETTINGS_NAVIGATION_ACCOUNT,
        LinkItemCode.Account,
        "/settings/account"
    ),
    subscription: new LinkItem(
        Strings.SETTINGS_NAVIGATION_SUBSCRIPTION,
        LinkItemCode.Subscription,
        "/settings/subscription"
    ),
    favorites: new LinkItem(
        Strings.SETTINGS_NAVIGATION_FAVORITES,
        LinkItemCode.Favorites,
        "/settings/favorites"
    ),
    settingsPlayer: new LinkItem(
        Strings.SETTINGS_NAVIGATION_PLAYER,
        LinkItemCode.SettingsPlayer,
        "/settings/player"
    ),
    parentControl: new LinkItem(
        Strings.SETTINGS_NAVIGATION_PARENT,
        LinkItemCode.ParentalControl,
        "/settings/parent-control"
    ),
    privacy: new LinkItem(
        Strings.SETTINGS_NAVIGATION_PRIVACY,
        LinkItemCode.Privacy,
        "/settings/privacy-policy"
    ),
    about: new LinkItem(
        Strings[`SETTINGS_NAVIGATION_ABOUT_${publisher}` as keyof typeof Strings],
        LinkItemCode.About,
        "/settings/about-us"
    ),
    clearCache: new LinkItem(
        Strings.SETTINGS_NAVIGATION_CLEAR_CACHE,
        LinkItemCode.ClearCache,
        "/settings/clear-cache"
    ),
    help: new LinkItem(
        Strings.SETTINGS_NAVIGATION_HELP,
        LinkItemCode.Help,
        "/help"
    ),
    language: new LinkItem(
        Strings.SETTINGS_NAVIGATION_LANGUAGE,
        LinkItemCode.Language,
        "/settings/language"
    ),
    login: new LinkItem(Strings.LOGIN_SIGNIN, LinkItemCode.Login, "/login"),
    logInSignIn: new LinkItem(Strings.LOGIN_SIGNIN, LinkItemCode.LogInSignIn, "/login/sign-in"),
    logInForgot: new LinkItem(Strings.LOGIN_SIGNIN, LinkItemCode.LogInForgot, "/login/forgot"),
    logInWelcomeScreen: new LinkItem(Strings.LOGIN_SIGNIN, LinkItemCode.LogInWelcomeScreen, "/login/welcome"),
    detailsVodMovies: new LinkItem(
        Strings.MENU_HOME,
        LinkItemCode.DetailsMovies,
        "/detailsVodMovies"
    ),
    detailsVodSeries: new LinkItem(
        Strings.MENU_HOME,
        LinkItemCode.DetailsSeries,
        "/detailsVodSeries"
    ),
    detailsPrograms: new LinkItem(
        Strings.MENU_HOME,
        LinkItemCode.DetailsPrograms,
        "/detailsPrograms"
    ),
    showAllSearch: new LinkItem(
        '',
        LinkItemCode.ShowAllSearch,
        `/search/show-all`
    ),
    searchLiveTV: new LinkItem(
        Strings.SEARCH_LIVE_TV,
        LinkItemCode.SearchLiveTV,
        `/search/show-all?type=${ShowAllContentType.Live}`
    ),
    searchChannels: new LinkItem(
        Strings.SEARCH_CHANNELS,
        LinkItemCode.SearchChannels,
        `/search/show-all?type=${ShowAllContentType.Channels}`
    ),
    searchMovies: new LinkItem(
        Strings.SEARCH_MOVIES_ON_DEMAND,
        LinkItemCode.SearchMovies,
        `/search/show-all?type=${ShowAllContentType.Movies}`
    ),
    searchShows: new LinkItem(
        Strings.SEARCH_TV_SHOWS_ON_DEMAND,
        LinkItemCode.SearchShows,
        `/search/show-all?type=${ShowAllContentType.Shows}`
    ),
    searchCredits: new LinkItem(
        Strings.SEARCH_CAST_AND_CREW,
        LinkItemCode.SearchCastAndCrew,
        `/search/show-all?type=${ShowAllContentType.Credits}`
    ),
    player: new LinkItem(
        "",
        LinkItemCode.Player,
        "/player"
    ),
    trailer: new LinkItem(
        "",
        LinkItemCode.Trailer,
        "/trailer"
    ),
    showAllVod: new LinkItem(
        '',
        LinkItemCode.ShowAllVod,
        `/vod/show-all`
    ),
    showAllMostPopular: new LinkItem(
        Strings.VOD_MOST_POPULAR,
        LinkItemCode.ShowAllMostPopular,
        `/vod/show-all?type=${ShowAllContentType.MostPopularVod}`
    ),
    showAllRecentlyOnDemand: new LinkItem(
        Strings.VOD_NEW_RELEASES,
        LinkItemCode.ShowAllVodRecentlyOnDemand,
        `/vod/show-all?type=${ShowAllContentType.RecentlyOnDemand}`
    ),
    showAllContinueWatchingVod: new LinkItem(
        Strings.HOME_FIZZ_CONTINUE_WATCHING,
        LinkItemCode.ShowAllContinueWatching,
        `/vod/show-all?type=${ShowAllContentType.ContinueWatching}`
    ),
    showAllWatchAgain: new LinkItem(
        Strings.HOME_WATCH_AGAIN,
        LinkItemCode.ShowAllWatchAgain,
        `/vod/show-all?type=${ShowAllContentType.WatchAgain}`
    ),
    showAllHomeTrends: new LinkItem(
        Strings.HOME_TRENDS,
        LinkItemCode.ShowAllHomeTrends,
        `/home/show-all?type=${ShowAllContentType.Trends}`
    ),
    showAllHomeMovies: new LinkItem(
        Strings.HOME_MOVIES,
        LinkItemCode.ShowAllHomeMovies,
        `/home/show-all?type=${ShowAllContentType.Movies}`
    ),
    showAllHomeSports: new LinkItem(
        Strings.HOME_SPORTS,
        LinkItemCode.ShowAllHomeSports,
        `/home/show-all?type=${ShowAllContentType.Sports}`
    ),
    showAllHomeKids: new LinkItem(
        Strings.HOME_KIDS,
        LinkItemCode.ShowAllHomeKids,
        `/home/show-all?type=${ShowAllContentType.Kids}`
    ),
    showAllHomeNews: new LinkItem(
        Strings.HOME_NEWS,
        LinkItemCode.ShowAllHomeNews,
        `/home/show-all?type=${ShowAllContentType.News}`
    ),
    showAllHomeRecentlyOnDemand: new LinkItem(
        Strings.HOME_RECENTLY_ON_DEMAND,
        LinkItemCode.ShowAllHomelRecentlyOnDemand,
        `/home/show-all?type=${ShowAllContentType.RecentlyOnDemand}`
    ),
    showAllHomeOlympics: new LinkItem(
        Strings.HOME_OLYMPICS,
        LinkItemCode.ShowAllHomeOlympics,
        `/home/show-all?type=${ShowAllContentType.Olympics}`
    ),
    showAllHomeContinueWatching: new LinkItem(
        Strings.HOME_CONTINUE_WATCHING,
        LinkItemCode.ShowAllHomeContinueWatching,
        `/home/show-all?type=${ShowAllContentType.ContinueWatching}`
    ),
    showAllHomeWatchAgain: new LinkItem(
        Strings.HOME_WATCH_AGAIN,
        LinkItemCode.ShowAllHomeWatchAgain,
        `/home/show-all?type=${ShowAllContentType.WatchAgain}`
    ),
    showAllHomeLiveSeries: new LinkItem(
        Strings.HOME_LIVE_SERIES,
        LinkItemCode.ShowAllHomeLiveSeries,
        `/home/show-all?type=${ShowAllContentType.LiveSeries}`
    ),
    showAllHome: new LinkItem(
        '',
        LinkItemCode.ShowAllHome,
        `/home/show-all`
    ),
    softwareLicense: new LinkItem(
        Strings.SETTINGS_NAVIGATION_SOFTWARE_LICENSE,
        LinkItemCode.softwareLicense,
        "/settings/software-license",
    ),

    freedomService: new LinkItem(
        Strings.SETTINGS_NAVIGATION_FREEDOM_SERVICE,
        LinkItemCode.freedomService,
        "/settings/service",
    ),
    devMode: new LinkItem(
        Strings.SETTINGS_NAVIGATION_DEVMODE,
        LinkItemCode.DevMode,
        "/settings/dev-mode",
    ),
    detailCast: new LinkItem(
        Strings.DETAILS_CASTNCREW_TITLE,
        LinkItemCode.DetailCast,
        `/detailsCast`
    ),
};
